import { render, staticRenderFns } from "./ContactForPurchase.vue?vue&type=template&id=6d32a9d0&scoped=true"
import script from "./ContactForPurchase.vue?vue&type=script&lang=js"
export * from "./ContactForPurchase.vue?vue&type=script&lang=js"
import style0 from "./ContactForPurchase.vue?vue&type=style&index=0&id=6d32a9d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d32a9d0",
  null
  
)

export default component.exports